module.exports = __webpack_public_path__ + "img/reception 1.113cf738.jpeg";